export const overlayLayers = {
    // Default page-level popup/dropdown overlays.
    overlayPopover: 900,
    // Page-level runtime update banner.
    overlayRuntimeBanner: 950,
    // Modal root backdrop/shell.
    overlayBackdrop: 1000,
    // Main modal content above backdrop.
    overlayModalContent: 1010,
    // Popups that must appear over modal content.
    overlayModalPopover: 1020,
    // Global non-blocking notifications.
    overlayToast: 1100,
    // Blocking runtime compatibility shield.
    overlayRuntimeHardStopBackdrop: 1200,
    // Blocking runtime compatibility content above shield.
    overlayRuntimeHardStopContent: 1210,
} as const;

export const surfaceLayers = {
    // Sticky table/header/footer elements.
    surfaceStickyBase: 20,
    // Sticky elements that must rise above base sticky surfaces.
    surfaceStickyRaised: 30,
} as const;
